{
  "version": 1,
  "asset_id": "6a6d6d39-8fd5-4c7b-8578-89bb0922b69e",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/6a6d6d39-8fd5-4c7b-8578-89bb0922b69e/destination-roofing-owner-sales-team-crystal-river-fl-480w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/6a6d6d39-8fd5-4c7b-8578-89bb0922b69e/destination-roofing-owner-sales-team-crystal-river-fl-480w.avif",
  "original_filename": "destination-roofing-owner-sales-team-crystal-river-fl-480w.avif",
  "size": 12383,
  "content_type": "image/avif",
  "created_at": "2026-07-21T15:42:45Z"
}
